/**
 * ES6 port of davidwalsh's debounce function
 * https://dev.to/monaye/refactor-davidwalsh-s-debounce-function-5afc
 * @param {*} func
 * @param {*} delay
 * @param {*} immediate
 */

export const debounce = (func, delay, immediate) => {
  let timerId;
  return (...args) => {
    const boundFunc = func.bind(this, ...args);
    clearTimeout(timerId);
    if (immediate && !timerId) {
      boundFunc();
    }
    const calleeFunc = immediate
      ? () => {
          timerId = null;
        }
      : boundFunc;
    timerId = setTimeout(calleeFunc, delay);
  };
};

export default debounce;
